import { defineStaticService, implementStaticService } from '@wix/static-service'
import type { StaticServiceDefinition, StaticServiceFactoryOpts } from '@wix/static-service'
import { createPlaceholderGetter } from './imagePlaceholder'
import type { IImagePlaceholderService, IImagePlaceholderConfig } from './types'
import { getPlaceholder } from '@wix/image-kit'

export type IImagePlaceholderDefintion = StaticServiceDefinition<IImagePlaceholderService, IImagePlaceholderConfig>

export const ImagePlaceholderDefintion = defineStaticService<IImagePlaceholderService, IImagePlaceholderConfig>(
	'viewer-core/image-placeholder'
)

export const ImagePlaceholderService = implementStaticService(
	ImagePlaceholderDefintion,
	({ config }: StaticServiceFactoryOpts<IImagePlaceholderConfig>) => {
		// TODO get 'isSEOBot' and 'staticMediaUrl' from envDataService
		return createPlaceholderGetter(getPlaceholder, config)
	}
)
